const uuid = require('uuid');
import React from 'react';
import PropTypes from 'prop-types';
import { Row, Button, Modal } from 'react-bootstrap';
const validUrl = require('valid-url');

const _ = {
    find:       require('lodash/find'),
    filter:     require('lodash/filter'),
    map:        require('lodash/map'),
};

const Strings = require('../../../../app/shared/Strings');
const Globals = require('../../../../app/globals');

const ShortCourseEditorActions = require('../../actions/ShortCourseEditorActions');

const RSDActions = require('../../actions/RSDActions');
const RSDStore = require('../../stores/RSDStore');

const ForgeError = require('../../util/error');
import ErrorBox from '../common/ErrorBox';
import ControlledInput from '../common/ControlledInput';
import LoadingSpinner from '../loading/LoadingSpinner';
import AccessibleIcon from '../common/AccessibleIcon';

const propTypes = {
    doc: PropTypes.object.isRequired,
    subskill_hash: PropTypes.string.isRequired,
};

const defaultProps = {
};

class EditSubskillModal extends React.Component {
    constructor(props) {
        super(props);
        var ss = this.getStoreState(props);
        // let error = this.validate_rsd_id(props,subskill.rsd_id);
        this.state = {...ss,
            error:null,
        }
        this.unsubscribes = [
            RSDStore.listen(this.onRSDStoreChange),
        ];
    }

    componentDidMount() {
        if (!this.state.rsd_services_initialized) {
            let actionId = uuid.v4();
            this.setState({get_services_actionId: actionId},()=>{
                RSDActions.getChannelRSDServices(actionId,{channelId: this.props.channelId});
            });
        }
    }

    componentWillUnmount() {
        this.unsubscribes.forEach(u => u());
    }
    
    getStoreState=(props)=>{
        let subskill = _.find(props.doc.subskills,{hash: props.subskill_hash});
        let rsdState = this.getRSDState(props,subskill);
        return {subskill,...rsdState};
    }

    getRSDState=(props,subskill, override_rsd_service_id)=>{
        let rsdStoreState = RSDStore.getStateChannel(props.channelId);
        let services_initialized = false;
        let rsd_services = [];
        let rsds = [];
        if (rsdStoreState.rsdServices) {
            services_initialized = rsdStoreState.rsdServices.rsd_services ? true : false;
            rsd_services = rsdStoreState.rsdServices.rsd_services || [];
            rsds = rsdStoreState.rsdServices.rsds || [];
        }
        let known_rsds = [];
        let nameSyncNeeded = false;
        let descriptionSyncNeeded = false;
        if (subskill) {
            let rsd_service_id = override_rsd_service_id || subskill.rsd_service_id;
            let serviceData = _.find(rsd_services,{id:rsd_service_id});
            if (serviceData) {
                if (serviceData.service_type === Globals.RSD_SERVICE_TYPES.MZL) {
                    known_rsds = rsds && rsds[rsd_service_id];
                }
                else {
                    known_rsds = _.filter(rsdStoreState.external_rsds,{rsd_service_id});
                }
                if (subskill.rsd_id) {
                    let rsd = _.find(known_rsds,{rsd_id:subskill.rsd_id});
                    if (rsd) {
                        nameSyncNeeded  = (subskill.display_name !== rsd.name);
                        descriptionSyncNeeded = (subskill.description !== rsd.description);
                    }
                }
            }
        }
        return { services_initialized, rsd_services,rsds, known_rsds, nameSyncNeeded, descriptionSyncNeeded };
    }
    
//    getKnownRsds=()=>{
//        const subskill = _.find(this.props.doc.subskills,{hash: props.subskill_hash});
//        let known_rsds = this.state.known_rsds;
//        if (subskill) {
//            let rsdStoreState = RSDStore.getStateChannel(this.props.channelId);
//            let rsd_service_id = subskill.rsd_service_id;
//            let serviceData = _.find(rsd_services,{id:rsd_service_id});
//            if (serviceData) {
//                if (serviceData.service_type === Globals.RSD_SERVICE_TYPES.MZL) {
//                    known_rsds = rsds && rsds[rsd_service_id];
//                }
//                else {
//                    known_rsds = _.filter(rsdStoreState.external_rsds,{rsd_service_id});
//                }
//            }
//        }
//        return known_rsds;
//    }
    
    onRSDStoreChange=(state)=>{
        let rsdState = this.getRSDState(this.props, this.state.subskill);
        this.setState(rsdState);
        if (this.state.get_rsd_actionId && (state.action.id === this.state.get_rsd_actionId)) {
            this.setState({get_rsd_actionId: null});
        }
        else if (this.state.get_services_actionId && (state.action.id === this.state.get_services_actionId)) {
            this.setState({get_services_actionId: null});
        }
        else if (this.state.get_rsd_name_actionId && (state.action.id === this.state.get_rsd_name_actionId)) {
            this.setState({get_rsd_name_actionId: null});
            const rsd_id = this.state.subskill.rsd_id;
            let rsd = _.find(rsdState.known_rsds,{rsd_id});
            if (rsd) {
                this.setNameAndDescriptionFromRSD(rsd);
            }
            else {
                let error = new ForgeError({message: 'RSD ID not found'});
                this.setState({error});
            }
        }
    }

    setNameAndDescriptionFromRSD=(rsd)=>{
        let sameName = (this.state.subskill.display_name === rsd.name);
        let sameDescription = (this.state.subskill.description === rsd.description);
        if (sameName && sameDescription) {
            this.setState({
                nameSyncNeeded: false,
                descriptionSyncNeeded: false,
            });
        }
        let subskill = {...this.state.subskill,
            display_name: rsd.name,
            description: rsd.description,
            nameSyncNeeded: false,
            descriptionSyncNeeded: false,
        };
        this.setState({subskill,error:null},()=>{
            if (!sameName) {
                ShortCourseEditorActions.setSubskillValue(uuid.v4(),this.props.subskill_hash, 'display_name',rsd.name);
            }
            if (!sameDescription) {
                ShortCourseEditorActions.setSubskillValue(uuid.v4(),this.props.subskill_hash, 'description',rsd.description);
            }
        });
    }
    
    // use known_rsds to fill in name and/or description
    syncNameAndDescription=()=>{
        let rsd = _.find(this.state.known_rsds,{rsd_id:this.state.subskill.rsd_id});
        if (rsd) {
            this.setNameAndDescriptionFromRSD(rsd);
        }
    }
    
    lookup_rsd_id=()=>{
        const rsd_id = this.state.subskill.rsd_id;
        const rsd_service_id = this.state.subskill.rsd_service_id;
        if (!rsd_id || !rsd_service_id) {
            return;
        }
        
        if (!validUrl.isHttpUri(rsd_id) && !validUrl.isHttpsUri(rsd_id)) {
            this.setState({ error: new ForgeError({message: 'RSD url is invalid'}) });
            return;
        }
        
        let serviceData = _.find(this.state.rsd_services,{id:rsd_service_id});
        if (!serviceData) {
            this.setState({ error: new ForgeError({message: 'RSD url is invalid'}) });
            return;
        }
        
        if (serviceData.service_type === Globals.RSD_SERVICE_TYPES.MZL) {
            if (this.state.rsds && this.state.rsds[rsd_service_id]) {
                let rsd = _.find(this.state.rsds[this.state.subskill.rsd_service_id],{rsd_id});
                if (rsd) {
                    this.setNameAndDescriptionFromRSD(rsd);
                }
                else {
                    let error = new ForgeError({message: 'RSD ID not found'});
                    return this.setState({error});
                }
            }
            else {
                let actionId = uuid.v4();
                this.setState({
                    get_rsd_actionId: actionId,
                    error: null},()=>{
                    RSDActions.getChannelServiceRSDs(actionId,{channelId: this.props.channelId, rsd_service_id});
                });
            }
        }
        else {
            // look up one at a time
            let actionId = uuid.v4();
            this.setState({get_rsd_name_actionId: actionId, error: null},()=>{
                RSDActions.getNameAndDescription(actionId,{channelId: this.props.channelId, rsd_service_id, rsd_id });
            });
        }
    }
    
    get_rsds=()=>{
        const rsd_service_id = this.state.subskill.rsd_service_id;
        if (!rsd_service_id) {
            return;
        }
        
        let serviceData = _.find(this.state.rsd_services,{id:rsd_service_id});
        if (!serviceData) {
            return;
        }
        
        if (serviceData.service_type !== Globals.RSD_SERVICE_TYPES.MZL) {
            return;
        }

        let rsdStoreState = RSDStore.getStateChannel(this.props.channelId);
        if (rsdStoreState.rsdServices) {
            if (rsdStoreState.rsdServices.rsd_services) {
                let rsds = rsdStoreState.rsdServices.rsds;
                if (rsds) {
                    let known_rsds = rsds[rsd_service_id];
                    if (known_rsds) {
                        return; // we already have the known rsds
                    }
                }
            }
        }

        let actionId = uuid.v4();
        this.setState({get_rsds_actionId: actionId, error: null},()=>{
            RSDActions.getChannelServiceRSDs(actionId,{channelId: this.props.channelId, rsd_service_id});
        });
    }

    setSubskillValue=(key,evt,considerLookup)=>{
        let value = evt.target.value;
        ShortCourseEditorActions.setSubskillValue(uuid.v4(),this.props.subskill_hash, key,value );
        let subskill = {...this.state.subskill};
        subskill[key] = value;
        let changes = {subskill};
        let rsd_change = false;
        if (key === 'rsd_id' || key === 'rsd_service_id') {
            changes.error = null; // clear error
            let rsdState = this.getRSDState(this.props, subskill, changes.subskill.rsd_service_id);
            changes = {...changes, ...rsdState };
            rsd_change = true;
        }
        this.setState(changes,()=>{
            if (rsd_change && considerLookup) {
                this.lookup_rsd_id();
            }
            if (rsd_change && (key === 'rsd_service_id')) {
                this.get_rsds();
            }
        });
    }
    
    setService=(evt)=>{
        this.setSubskillValue('rsd_service_id',evt,true);
    }

    render() {
        const rsd_service_id = this.state.subskill.rsd_service_id;
        const rsd_id = this.state.subskill.rsd_id;
        const actionInProgress = (this.state.get_services_actionId || this.state.get_rsd_actionId || this.state.get_rsd_name_actionId);
        const readOnlyNameAndDescription = (actionInProgress || (rsd_service_id && rsd_id));
        

        let rsd_selector;
        if (this.state.known_rsds && this.state.known_rsds.length) {
            rsd_selector = (
                <select id="subskill-rsd-id-selector" value={''} 
                    readOnly={actionInProgress}
                    onChange={ (evt)=>{ this.setSubskillValue('rsd_id',evt,true)} }>
                    <option key="none" value={''}>{''}</option>
                    {this.state.known_rsds.map((rsd)=>(
                    <option key={rsd.rsd_id} value={rsd.rsd_id} title={rsd.name}>{`${rsd.name}`}</option>
                    ))}
                </select>
            );
        }
        
        return (
            <Modal
                className="short-course-subskill-details-modal"
                show={true}
                keyboard
                autoFocus
                enforceFocus={false}
                restoreFocus={false}
                backdrop={false}
                animation={false}
                //container={mountNode}
                onHide={this.props.closeHandler}
                aria-labelledby="subskill-editor"
            >
                <Modal.Header
                    closeButton
                    closeLabel={Strings['en'].common.CLOSE}
                    onHide={this.props.closeHandler}
                >
                    <Modal.Title id="subskill-editor">{'Subskill Details'}</Modal.Title>
                </Modal.Header>

                <Modal.Body>
                    <div className="formlike subskill-editor-body">
                        <div className="formlike">
                            <label htmlFor="modal-edit-rsd-service-id">{Strings['en'].RSD.RSD_SERVICE_LABEL + ':'}</label>
                            <select id="modal-edit-rsd-service-id" 
                                    value={this.state.subskill.rsd_service_id||0} 
                                    onChange={this.setService} readOnly={actionInProgress}>
                                <option key="none" value={0}>None</option>
                                {this.state.rsd_services.map((rsd_service)=>(
                                <option key={rsd_service.id} value={rsd_service.id}>{rsd_service.name}</option>
                                ))}
                            </select>
                        </div>
                        <div className="formlike">
                            <label htmlFor="subskill-rsd-id">{'RSD ID:'}</label>
                            <div className="input-well">
                                {rsd_selector}
                                <ControlledInput id="subskill-rsd-id" type="text" readOnly={actionInProgress}
                                value={this.state.subskill.rsd_id||''} 
                                onChange={this.setSubskillValue.bind(this,'rsd_id')}
                                onBlur={this.lookup_rsd_id}
                                />
                            </div>
                        </div>
                        <div className="formlike">
                            <label htmlFor="subskill-name">{'Name:'}</label>
                            <div className="input-well">
                                <ControlledInput id="subskill-name" type="text" 
                                    value={this.state.subskill.display_name} 
                                    readOnly={readOnlyNameAndDescription}
                                    onChange={this.setSubskillValue.bind(this,'display_name')}/>
                                {this.state.nameSyncNeeded ? 
                                <button title="reload" onClick={this.syncNameAndDescription}>
                                    <AccessibleIcon className="fa fa-refresh" label="load from RSD"/> 
                                </button>
                                : null }
                            </div>
                        </div>
                        <div className="formlike">
                            <label htmlFor="subskill-description">{'Description:'}</label>
                            <div className="input-well">
                                <ControlledInput id="subskill-description" type="text" 
                                    value={this.state.subskill.description} 
                                    readOnly={readOnlyNameAndDescription}
                                    onChange={this.setSubskillValue.bind(this,'description')}/>
                                {this.state.descriptionSyncNeeded ? 
                                <button title="reload" onClick={this.syncNameAndDescription}>
                                    <AccessibleIcon className="fa fa-refresh" label="load from RSD"/> 
                                </button>
                                : null }
                            </div>
                        </div>
                        { actionInProgress ? <LoadingSpinner/> : null }
                    </div>
                    <ErrorBox error={this.state.error} />
                </Modal.Body>
                <Modal.Footer>
                </Modal.Footer>
            </Modal>
        );
    } // render
}; // EditSubskillModal

EditSubskillModal.propTypes = propTypes;
EditSubskillModal.defaultProps = defaultProps;

export default EditSubskillModal;